import useAuth, {useAuthIsGhost, useIsLoggedIn} from "@irati/auth/helpers/auth/useAuth"
import React, {useState} from "react"
import tracker, {Tracker, TrackingStorage} from "./tracker"

interface Props {
  children: React.ReactNode
  trackerFactory: TrackerFactory
  storage: TrackingStorage
}

export type TrackerFactory = (opts: {isGhost: boolean}) => Promise<Tracker>

export {getTrackingConfig} from "./config"

export function TrackingProvider({children, trackerFactory, storage}: Props) {
  const [platform, setPlatform] = useState<Tracker>()
  const isLoggedIn = useIsLoggedIn()
  const [loggedInState, setLoggedInState] = useState<boolean>()
  const {isGhost} = useAuthIsGhost()
  const auth = useAuth()

  // Once user is logged in, we setup the tracker (which is a global singleton sadly)
  if (auth.user && !platform) {
    trackerFactory({isGhost: !!isGhost}).then((p) => {
      setPlatform(p)
    })
  }

  if (platform && isLoggedIn !== loggedInState) {
    setLoggedInState(isLoggedIn)

    if (isLoggedIn) {
      if (!auth.user || !auth.business) console.error("TrackingProvider: missing auth data")
      else {
        tracker.trackLogin({
          user: auth.user,
          business: auth.business,
          platform,
          storage
        })
      }
    } else {
      tracker.trackLogout()
    }
  }

  // NOTE: hoping to set up a context so consumers use a hook rather than the singleton
  return <>{children}</>
}
